import * as React from 'react';
import { Divider, Typography, Row, Col } from 'antd';
import Banner from "../full_banner.png";
const { Title, Paragraph, Text, Link } = Typography;

export interface IntroViewProps {
    contentWidth: number,
    contentHeight: number
}

export interface IntroViewState {}

export default class IntroView extends React.Component<IntroViewProps, IntroViewState> {
    constructor(props: IntroViewProps) {
        super(props);
        this.state = {
            
        };
    }
    public render() {
        let {contentWidth} = this.props;
        let breakpoint = 540;
        let img_style1 = {"height": "120px"};
        let img_style2 = {"width": "100%"};
        let used_style:any = img_style1;
        let col_size = 4;
        
        if(contentWidth > breakpoint){
            used_style = img_style1;
            col_size = 4;
        }else{
            used_style = img_style2;
            col_size = 0;
        }
        let center_size = 24 - 2*col_size;
        let generateHighlight = (text:any) => {
            return <span style={{"color":"purple"}}><strong>{text}</strong></span>
        }
        return (

            <div className="IntroViewBox2">
                <div style={{"textAlign": "center"}}>
                <img src={Banner} style={used_style} alt="banner"/>
                
                </div>
                
                <Row>
                    <Col span={col_size}></Col>
                <Col span={center_size}>
                <Divider></Divider>
                <Typography>
                
                {/*<Title level={3}>HAPI: A Large-scale Longitudinal Dataset of Commercial ML API Predictions</Title>*/}
                {/*<Paragraph>
                Commercial ML APIs offered by providers such as Google, Amazon and Microsoft have dramatically simplified ML adoption in many applications. Numerous companies and academics pay to use ML APIs for tasks such as object detection, OCR and sentiment analysis. Different ML APIs tackling the same task can have very heterogeneous performance. Moreover, the ML models underlying the APIs also evolve over time. As ML APIs rapidly become a valuable marketplace and a widespread way to consume machine learning, it is critical to systematically study and compare different APIs with each other and to characterize how APIs change over time. However, this topic is currently underexplored due to the lack of data. Here, we present HAPI (History of APIs), a longitudinal dataset of 1,761,417 instances of commercial ML API applications (involving APIs from Amazon, Google, IBM, Microsoft and other providers) across diverse tasks including image tagging, speech recognition and text mining from 2020 to 2022. Each instance consists of a query input for an API (e.g., an image or text) along with the API’s output prediction/annotation and confidence scores. HAPI is the first large-scale dataset of ML API usages and is a unique resource for studying ML-as-a-service (MLaaS). As examples of the types of analyses that HAPI enables, we show that ML APIs’ performance change substantially over time—several APIs’ accuracies dropped on specific benchmark datasets. Even when the API’s aggregate performance stays steady, its error modes can shift across different subtypes of data between 2020 and 2022. Such changes can substantially impact the entire analytics pipelines that use some ML API as a component. We further use HAPI to study commercial APIs’ performance disparities across demographic subgroups over time. HAPI can stimulate more research in the growing field of MLaaS.
        </Paragraph>*/}
                <Paragraph style={{"fontSize": "20px"}}>
                {generateHighlight("History of APIs (HAPI) is a large-scale, longitudinal database of commercial ML API predictions.")} It contains 1.7 million predictions collected from 2020 to 2022 and spanning APIs from Amazon, Google, IBM, and Microsoft. The database includes diverse machine learning tasks, including image tagging, speech recognition and text mining.

                </Paragraph>
                <Divider></Divider>
                <Paragraph style={{"fontSize": "20px"}}>
                Contact: Lingjiao Chen (lingjiao at stanford.edu), Zhihua Jin (zjinak@connect.ust.hk), and James Zou (jamesz at stanford.edu).
                </Paragraph>

            </Typography>
            </Col>
            <Col span={col_size}></Col>
            </Row>
            </div>
            
            
        );
    }
}
